export default [
 
    {
      title: 'Dashboard',
      route: 'dashboard',
      icon: 'HomeIcon',
    },
]
  
  